import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { branch, compose, lifecycle, renderNothing, withHandlers } from 'recompose';
import { t } from '../../../modules/infra/i18n';
import { getShopBrandId, isBrandViewActive } from '../../auth/selectors';
import confirmModal from '../../common/confirmModal';
import { trimFunction } from '../../common/trimData';
import SimpleHeader from '../../main/headers/simpleHeader';
import { withBindRouterIdToActions } from '../hoc/withBindRouterIdToActions';
import * as shapes from '../shapes';
import { deleteBrandItem, fetchBrandItem, updateBrandItem } from './actions';
import Form from './Form';
import * as selectors from './selectors';

class Edit extends Component {
  onDelete = async () => {
    const confirmed = await confirmModal({
      type: 'danger',
      title: t('products:brands.delete_modal.title'),
      message: t('products:brands.delete_modal.message'),
    });

    if (confirmed) {
      await this.props.onDelete();
      this.props.router.push(this.props.baseUrl);
    }
  };

  render() {
    return (
      <div>
        <SimpleHeader heading={t('products:brands.edit_heading')} />
        <Form
          initialValues={this.props.item}
          onSubmit={trimFunction(this.props.onSubmit)}
          onDelete={this.onDelete}
          baseUrl={this.props.baseUrl}
          edit
        />
      </div>
    );
  }
}

Edit.propTypes = {
  onSubmit: shapes.handler.isRequired,
  onDelete: shapes.handler.isRequired,
  item: shapes.brand.isRequired,
  baseUrl: shapes.url.isRequired,
};

const getBaseUrl = (isBarber, isBrand) => {
  if (isBrand) {
    return '/brand/products/brands';
  }

  if (isBarber) {
    return '/barber/products/brands';
  }

  return '/products/brands';
};

const mapStateToProps = (state, ownProps) => ({
  item: selectors.byId(state, ownProps.params.id),
  baseUrl: getBaseUrl(state.auth.barberUser, isBrandViewActive(state)),
  brandId: getShopBrandId(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    fetchBrandItem,
    updateBrandItem,
    deleteBrandItem,
  }),
  withHandlers({
    fetchData: props => id => props.fetchBrandItem(props.brandId, id),
    onSubmit: props => (id, data) => props.updateBrandItem(props.brandId, id, data),
    onDelete: props => id => props.deleteBrandItem(props.brandId, id),
  }),
  withBindRouterIdToActions(['onSubmit', 'onDelete', 'fetchData']),
  lifecycle({
    componentDidMount() {
      if (!this.props.item) this.props.fetchData();
    },
  }),
  branch(
    props => !props.item,
    renderNothing,
  ),
)(Edit);
